module.exports = __webpack_public_path__ + "img/Exodus_logo_dark.4284a94e.png";